import {
  IB_PYP_ELEMENT_TYPE_DP,
  IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE,
  IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_DP_EE,
  IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE_2027,
  IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE_2027,
} from "Projects/Constants/stringConstants";

export const FINAL_GRADE_SUBTEXT = {
  [PROJECT_GROUP_TYPE_DP_EE]: "project:predictive_grade_subtext",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]:
    "project:rp_predictive_grade_subtext",
};

export const getFinalGradeAcademicCriteriaSetSubType = ({
  isDescriptorV2 = false,
  projectGroupType,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_DP_EE:
      return isDescriptorV2 ? "EE_2027" : "EE";
    case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
      return isDescriptorV2 ? "RP_2027" : "RP";
    default:
      return null;
  }
};

export const getFinalGradeAcademicCriteriaValueFilters = ({
  isDescriptorV2 = false,
  projectGroupType,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_DP_EE:
      return {
        elementTypes: IB_PYP_ELEMENT_TYPE_DP,
        subTypes: isDescriptorV2
          ? IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE_2027
          : IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE,
      };
    case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
      return {
        elementTypes: IB_PYP_ELEMENT_TYPE_DP,
        subTypes: isDescriptorV2
          ? IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE_2027
          : IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE,
      };
    default:
      return {};
  }
};
